import { Link, Outlet, useNavigate } from "react-router-dom";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import "../styles/Navigation.css";
import { FaSignOutAlt } from "react-icons/fa";

const HomeCustomer = () => {
  const [username, setUsername] = useState("");
  const [expanded, setExpanded] = useState(false); // 👈 controls navbar collapse
  const navigate = useNavigate();

  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    setUsername(storedUsername || "Guest");
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const handleNavLinkClick = () => {
    setExpanded(false); // 👈 collapse navbar on link click
  };

  return (
    <>
      {/* Top Banner */}
      <img
        src="/images/banner_2.png"
        className="banner-img"
        alt="Company Banner"
      />

      <Navbar
        bg="dark"
        variant="dark"
        expand="lg"
        className="custom-navbar"
        expanded={expanded} // 👈 control toggle state
        onToggle={() => setExpanded(prev => !prev)}
      >
        <Container>
          <Navbar.Brand as={Link} to="." className="brand-logo">
            <img
              src="/images/logo1.png"
              width="50"
              height="50"
              className="logo-img"
              alt="Company Logo"
            />
            <span className="company-name">SAL PITA</span>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="." onClick={handleNavLinkClick}>Home</Nav.Link>
              <Nav.Link as={Link} to="make" onClick={handleNavLinkClick}>Make Order</Nav.Link>
              <Nav.Link as={Link} to="ManageOrder" onClick={handleNavLinkClick}>Manage Orders</Nav.Link>
              <Nav.Link as={Link} to="track" onClick={handleNavLinkClick}>Track Order</Nav.Link>
              <Nav.Link as={Link} to="paymentHistory" onClick={handleNavLinkClick}>Payment History</Nav.Link>
              <Nav.Link as={Link} to="profile" onClick={handleNavLinkClick}>Profile</Nav.Link>
            </Nav>

            {/* Right Side */}
            <div className="d-flex align-items-center gap-2 text-white ms-auto">
              <span style={{ fontSize: "0.9rem" }}>
                Welcome, <strong>{username}</strong>
              </span>
              <Button
                variant="outline-light"
                size="sm"
                onClick={handleLogout}
                style={{ padding: "0.25rem 0.6rem", fontSize: "0.85rem" }}
              >
                <FaSignOutAlt className="me-1" />
                Logout
              </Button>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Main Page Content */}
      <div className="mt-4 px-3">
        <Outlet />
      </div>
    </>
  );
};

export default HomeCustomer;
